import { type KeyboardEvent, type MouseEvent, useEffect, useRef, useState } from 'react';
import { useIsDesktop } from '@/src/lib/hooks/ui/useIsDesktop';

export function useMobileAutocomplete() {
  const isDesktop = useIsDesktop();
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const isMobile = !isDesktop;
  const close = () => setOpen(false);

  useEffect(() => {
    if (isDesktop) setOpen(false);
  }, [isDesktop]);

  return {
    isMobile,
    open: isMobile && open,
    close,
    inputRef,
    triggerProps: {
      onClickCapture: (event: MouseEvent<HTMLElement>) => {
        if (!isMobile || !(event.target instanceof Element) || event.target.closest('button')) return;
        event.stopPropagation();
        inputRef.current?.focus();
        setOpen(true);
      },
    },
    inputProps: isMobile
      ? {
          readOnly: true,
          role: 'button',
          'aria-haspopup': 'dialog' as const,
          'aria-expanded': open,
          'aria-autocomplete': undefined,
          onKeyDownCapture: (event: KeyboardEvent<HTMLInputElement>) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            event.stopPropagation();
            setOpen(true);
          },
        }
      : {},
  };
}
